import { useGetUserQuery } from 'services/userApi'

export const Profile = () => {
  const { data: user } = useGetUserQuery()
  return <></>
}
